<script setup lang="ts">
  import InputQC from '@qicgroupdoha/qic-connect-ds/components/InputQC'
  import { PASSPORT_MASK_CONFIG } from '../../VisitorForm.constants'

  interface Props {
    modelValue: string
    errors?: string[]
    isValid: boolean
    disabled: boolean
    loading: boolean
  }

  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<template>
  <InputQC
    :model-value="modelValue"
    :errors="errors"
    name="passport"
    :label="$t('qlm_passport')"
    :is-valid="isValid"
    :mask-config="PASSPORT_MASK_CONFIG"
    :disabled="disabled"
    :max-length="20"
    :container-attrs="{ 'data-test': 'passport-input' }"
    :loading="loading"
    data-test="passport-input-inner"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
